import { defineMessages } from 'react-intl';

export const tokenPageMessages = defineMessages({
  blockchainInfoTitle: {
    defaultMessage: 'Token details',
  },
  bidCount: {
    defaultMessage: '{count, plural, one {# Bid} other {# Bids}}',
  },
  ownershipHistoryTitle: {
    defaultMessage: 'Card history',
  },
  last5Sales: {
    defaultMessage: 'Last {rarity} sales',
  },
  alsoAvailableOnPrimary: {
    defaultMessage: 'Also available on auctions',
  },
});
